import script from "./FiltroComponentSimplificado.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroComponentSimplificado.vue?vue&type=script&setup=true&lang=js"

import "./FiltroComponentSimplificado.vue?vue&type=style&index=0&id=185b41db&scoped=true&lang=css"
import "./FiltroComponentSimplificado.vue?vue&type=style&index=1&id=185b41db&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185b41db"]])

export default __exports__